<template>
  <!-- Navbar -->
  <header class="navbar navbar-expand-md sticky-top d-print-none" :class="{ 'menu-open': menu_open }">
    <div class="container-xl">
      <button class="navbar-toggler" type="button" aria-controls="navbar-menu" :aria-expanded="menu_open"
        aria-label="Toggle navigation" @click="menu_open = !menu_open">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="mobile-menu-backdrop" v-if="menu_open" @click="menu_open = false"></div>
      <h1 class="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3">
        <div>
          <a href="/">
            <img src="/img/logo.png" width="110" height="32" alt="Tabler" class="navbar-brand-image"> 
          </a>
          <div class="d-sm-none">
            <div class="nav-item text-reset text-center chaneLanguage">
              <a href="#"  @click="changeLanguage('en')">EN</a> | <a href="#" @click="changeLanguage('zh')">中</a>
            </div>
          </div>
        </div>
      </h1>
      <div class="navbar-nav flex-row order-md-last">
        <div class="d-none d-md-flex">
          <div class="nav-item dropdown">
            <a href="#" class="nav-link d-flex lh-1 text-reset p-0 show" data-bs-toggle="dropdown"
              aria-label="Open user menu" aria-expanded="true">
              {{ $t("Language") }}
            </a>
            <div class="dropdown-menu dropdown-menu-end dropdown-menu-arrow " data-bs-popper="static">
              <a href="#" class="dropdown-item" @click="changeLanguage('zh')">简体中文</a>
              <a href="#" class="dropdown-item" @click="changeLanguage('en')">English</a>
            </div>
          </div>
          <div @click="themeModeChange" class="nav-link px-10 hide-theme-dark themeModeChange" data-bs-toggle="tooltip"
            data-bs-placement="bottom" aria-label="Enable dark mode" data-bs-original-title="Enable dark mode">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
              stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path d="M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z"></path>
            </svg>
          </div>
          <div @click="themeModeChange" class="nav-link px-10 hide-theme-light themeModeChange" data-bs-toggle="tooltip"
            data-bs-placement="bottom" aria-label="Enable light mode" data-bs-original-title="Enable light mode">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
              stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path d="M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"></path>
              <path d="M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7">
              </path>
            </svg>
          </div>
        </div>
      </div>
      <div class="collapse navbar-collapse" :class="{ show: menu_open }" id="navbar-menu">
        <div class="d-flex flex-column flex-md-row flex-fill align-items-stretch align-items-md-center">
          <ul class="navbar-nav">
            <li class="nav-item active">
              <a class="nav-link" href="/home">
                <span class="nav-link-icon d-md-none d-lg-inline-block">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                    stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M5 12l-2 0l9 -9l9 9l-2 0" />
                    <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" />
                    <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" />
                  </svg>
                </span>
                <span class="nav-link-title">
                  {{ $t('Home') }}
                </span>
              </a>
            </li>
            <li class="nav-item d-md-none" v-for="item in list_products" :key="item.id">
              <a class="nav-link" :href="'/product/' + item.short_name.toLowerCase()">
                <span class="nav-link-title">{{ item.name }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import { global } from '../global.js'
export default {
  name: 'HomerBlock',
  data() {
    return {
      global: global,
      list_products: [],
      menu_open: false,
    };
  }, methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
    },
    themeModeChange() {
      var themeStorageKey = "tablerTheme";
      var currentTheme = localStorage.getItem(themeStorageKey);
      if (!currentTheme) {
        currentTheme = 'dark';
      } else {
        if (currentTheme == "dark") {
          currentTheme = 'light';
        } else {
          currentTheme = 'dark';
        }
      }
      localStorage.setItem(themeStorageKey, currentTheme);
      if (currentTheme === 'dark') {
        document.body.setAttribute("data-bs-theme", currentTheme);
      } else {
        document.body.removeAttribute("data-bs-theme");
      }
    },
    get_products_list() {
      global.postData("help_center/list_products").then(data => {
        if (data.code == 200) this.list_products = data.body;
      });
    }
  },
  created() {
    this.get_products_list();
  }
}
</script>
<style scoped>
.themeModeChange {
  cursor: pointer;
}
.chaneLanguage{
  margin-top: 15px;font-size: 14px;
}

@media (max-width: 767.98px) {
  .menu-open {
    z-index: 1040;
  }

  #navbar-menu {
    position: absolute;
    top: 100%;
    right: 0;
    left: 0;
    z-index: 2;
    padding: 8px 16px;
    background: var(--tblr-bg-surface);
    box-shadow: var(--tblr-box-shadow-lg);
  }

  .mobile-menu-backdrop {
    position: absolute;
    top: 100%;
    right: 0;
    left: 0;
    height: 100vh;
    z-index: 1;
    background: rgba(0, 0, 0, 0.35);
  }
}
</style>
